import React, { PureComponent } from "react";
import { ResponsiveContainer, BarChart, Bar, Cell, XAxis, YAxis, Tooltip } from "recharts";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleUp, faArrowAltCircleDown } from "@fortawesome/free-solid-svg-icons";

import numeral from "numeral";

import ExpandedToolTip from "components/Project/ExpandedTooltip";
import styles from "./style.module.css";

const CustomToolTip = (props) => {
  const { active, payload, unit, isCurrencyUnit } = props;
  if (!active || !payload) {
    return null;
  }

  const dataKey = payload[0] && payload[0].dataKey;
  const retPayload = payload[0] && payload[0].payload;

  if (!retPayload) {
    return null;
  }

  return (
    <div className={styles.cTooltip} style={{ fontSize: "14px", color: "#333" }}>
      <div>
        <strong>{retPayload.label}</strong>
      </div>
      <div>
        {isCurrencyUnit ? <span>{unit}</span> : <span />}
        {numeral(retPayload[dataKey]).format("0,0.[0]")}
        {!isCurrencyUnit ? <span style={{ marginLeft: "5px" }}>{unit}</span> : <span />}
      </div>
    </div>
  );
};

export default class TinyBarChart extends PureComponent {
  render() {
    const {
      bars,
      unit,
      warning,
      dataKey,
      isCurrencyUnit,
      hideText,
      barChartHeight,
      hideTooltip,
      extendedTooltip,
      extendedTooltipData,
      tooltipLabel,
      baselinesEnabled,
      isBusinessColors,
      noMargin,
      showExtendedTooltip
    } = this.props;

    if (bars === undefined) {
      return <div />;
    }

    const retDataKey = dataKey ? dataKey : "Cost";

    const isIncreasing = bars[1][retDataKey] - bars[0][retDataKey] < 0;

    const xDomain = [0, 0];
    bars &&
      bars.forEach((currBar) => {
        const value = currBar[retDataKey];
        if (value > 0) {
          xDomain[1] = Math.max(xDomain[1], value);
        } else if (value < 0) {
          xDomain[0] = Math.min(xDomain[0], value);
        }
      });

    return (
      <div className={styles.tinyBarChart}>
        {!hideText && (
          <div className={styles.tinyBarInfo}>
            <span className={styles.oDelta}>
              <span className={isIncreasing ? styles.increase : styles.decrease}>
                <FontAwesomeIcon
                  style={{ marginRight: "5px" }}
                  icon={isIncreasing ? faArrowAltCircleUp : faArrowAltCircleDown}
                />
              </span>
              {isCurrencyUnit ? <span>{unit}</span> : <span />}
              <span style={{ textTransform: "uppercase" }}>
                {numeral(Math.round(Math.abs(bars[0][retDataKey] - bars[1][retDataKey]))).format("0.0a")}
              </span>
              {warning ? warning : <div />}
            </span>
          </div>
        )}
        <ResponsiveContainer width="100%" height={barChartHeight ? barChartHeight : 40}>
          <BarChart
            data={bars}
            layout={"vertical"}
            margin={noMargin ? { top: 0, right: 0, bottom: 10, left: 0 } : { top: 0, right: 20, bottom: 10, left: 0 }}
          >
            <XAxis dataKey={retDataKey} type={"number"} domain={xDomain} hide unit={unit} />
            <YAxis dataKey={"label"} type={"category"} hide />
            {!hideTooltip && (
              <Tooltip
                content={
                  extendedTooltip && showExtendedTooltip ? (
                    <ExpandedToolTip
                      data={extendedTooltipData}
                      tooltipLabel={tooltipLabel}
                      baselinesEnabled={baselinesEnabled}
                    />
                  ) : (
                    <CustomToolTip unit={unit} isCurrencyUnit={isCurrencyUnit} />
                  )
                }
                position={extendedTooltip ? { x: -150, y: 10 } : {}}
                allowEscapeViewBox={{ x: false, y: true }}
              />
            )}
            <Bar dataKey={retDataKey}>
              {bars.map((p, index) => (
                <Cell
                  key={index}
                  fill={
                    index === 0
                      ? "#7E69D7"
                      : !isBusinessColors
                        ? "#E0E0E0"
                        : // I'm rolling back the color update here in order to not affect Aible Advanced
                          // Use the isBusinessColors prop to use these updated colors.
                          index === 1 && bars.length > 2 && !baselinesEnabled
                          ? "#19AB27"
                          : "#512F77"
                  }
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}
